/**
 * Persona-switch redirect contract.
 * Centralises the rule: switching to a persona whose customerType is
 * incompatible with the current route forces a redirect to /home.
 * This prevents dead-end pages (e.g. P1 landing on /pm/account/foo).
 */
import type { PersonaId } from "@petci/fixtures";

const PERSONA_INCOMPATIBLE_ROUTES: Record<PersonaId, RegExp[]> = {
  P1: [/^\/hotel\b/, /^\/pm\b/, /^\/batch-pay\b/],
  P2: [/^\/hotel\b/, /^\/pm\b/, /^\/batch-pay\b/],
  P3: [/^\/pm\b/],
  P4: [/^\/hotel\b/],
  // P5 is hidden in Phase 1; defensive — any route is considered incompatible.
  P5: [/.*/],
};

/** Returns "/home" if the new persona cannot view the current path, else null. */
export function shouldRedirectOnPersonaSwitch(
  newPersonaId: PersonaId,
  currentPathname: string,
): "/home" | null {
  const blocked = PERSONA_INCOMPATIBLE_ROUTES[newPersonaId];
  return blocked.some((re) => re.test(currentPathname)) ? "/home" : null;
}
